export default "__VITE_ASSET__CTJSkrGz__"